/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "../../EmployeeScreens/EMPLeavesRequest/EMPLeavesRequest.css";
import Select from "react-select";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import {
  Apiurl,
  GetToken,
  RemoveUserSession,
  calculateWorkingDays,
  getDurationEnumValue,
  getTimeLevelLeaveRestrictions,
} from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

const EMPLeavesRequest = () => {
  const [loading, setLoading] = useState(false);

  const LoginToken = GetToken();
  const [profileData, setProfileData] = useState([]);

  const navigate = useNavigate();
  const [minLeaveToDate, setMinLeaveToDate] = useState(null);
  const [errorLeaveType, setErrorLeaveType] = useState(false);
  const [errorLeaveFrom, setErrorLeaveFrom] = useState(false);
  const [errorLeaveTo, setErrorLeaveTo] = useState(false);
  const [errorNoOfDays, setErrorNoOfDays] = useState(false);
  const [errorReason, setErrorReason] = useState(false);
  const [errorMedicalDoc, setErrorMedicalDoc] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [data, setdata] = useState("");

  // SINGLE FILE ONLY
  const [medicalDocumentFile, setMedicalDocumentFile] = useState(null);
  const fileInputRef = useRef(null);

  const [leaveFromType, setLeaveFromType] = useState("Full Day");
  const [leaveToType, setLeaveToType] = useState("Full Day");
  const [leaveFromSlot, setLeaveFromSlot] = useState(null);
  const [leaveToSlot, setLeaveToSlot] = useState(null);
  const [fromDateRestrictions, setFromDateRestrictions] = useState(null);
  const [toDateRestrictions, setToDateRestrictions] = useState(null);

  const [applyLeaves, setApplyLeaves] = useState({
    Name: "",
    LeaveType: "",
    LeaveFrom: "",
    LeaveTo: "",
    NoOfDays: "",
    Reason: "",
    ApplyForUserId: "",
  });

  const [allLeavesList, setallLeavesList] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const location = useLocation();
  const leaveRequestData = location.state?.leaveRequestData;

  useEffect(() => {
    if (leaveRequestData) {
      setApplyLeaves({
        LeaveType: leaveRequestData?.LeaveTypes,
        LeaveFrom: leaveRequestData?.StartDate?.split("T")[0],
        LeaveTo: leaveRequestData?.EndDate?.split("T")[0],
        NoOfDays: leaveRequestData?.NumberofDays,
        Reason: leaveRequestData?.Reason,
        ApplyForUserId: "",
      });
    }
  }, [leaveRequestData]);

  useEffect(() => {
    const fetchHolidays = () => {
      const option = {
        method: "GET",
        headers: {
          authorization: `Bearer ${LoginToken}`,
        },
        url: `${Apiurl()}/Holiday/GetAllHoliday`,
      };

      axios(option)
        .then((response) => {
          const holidayData = JSON.parse(response?.data?.data || "[]");
          const holidayDates = holidayData?.map((h) => h.HolidayDate);
          setHolidays(holidayDates || []);
        })
        .catch(() => {
          setHolidays([]);
        });
    };

    fetchHolidays();
  }, [LoginToken]);

  useEffect(() => {
    if (applyLeaves?.LeaveFrom) {
      const fromRestrictions = getTimeLevelLeaveRestrictions(
        applyLeaves?.LeaveFrom
      );
      setFromDateRestrictions(fromRestrictions);

      if (
        leaveFromSlot &&
        leaveFromType === "Half Day" &&
        !fromRestrictions.availableHalfDaySlots.includes(parseInt(leaveFromSlot))
      ) {
        setLeaveFromSlot(null);
      } else if (
        leaveFromSlot &&
        leaveFromType === "Short Day" &&
        !fromRestrictions.availableShortLeaveSlots.includes(
          parseInt(leaveFromSlot)
        )
      ) {
        setLeaveFromSlot(null);
      }
    }

    if (applyLeaves?.LeaveTo) {
      const toRestrictions = getTimeLevelLeaveRestrictions(applyLeaves?.LeaveTo);
      setToDateRestrictions(toRestrictions);

      if (
        leaveToSlot &&
        leaveToType === "Half Day" &&
        !toRestrictions.availableHalfDaySlots.includes(parseInt(leaveToSlot))
      ) {
        setLeaveToSlot(null);
      } else if (
        leaveToSlot &&
        leaveToType === "Short Day" &&
        !toRestrictions.availableShortLeaveSlots.includes(
          parseInt(leaveToSlot)
        )
      ) {
        setLeaveToSlot(null);
      }
    }
  }, [
    applyLeaves?.LeaveFrom,
    applyLeaves?.LeaveTo,
    leaveFromType,
    leaveToType,
    leaveFromSlot,
    leaveToSlot,
  ]);

  useEffect(() => {
    if (applyLeaves?.LeaveFrom && applyLeaves?.LeaveTo) {
      const days = calculateWorkingDays(
        applyLeaves?.LeaveFrom,
        applyLeaves?.LeaveTo,
        holidays,
        leaveFromType,
        leaveToType
      );

      setApplyLeaves((prev) => ({
        ...prev,
        NoOfDays: days,
      }));
    }
  }, [
    applyLeaves?.LeaveFrom,
    applyLeaves?.LeaveTo,
    leaveFromType,
    leaveToType,
    leaveFromSlot,
    leaveToSlot,
    holidays,
  ]);

  const validate = () => {
    if (!applyLeaves?.LeaveFrom) {
      setErrorLeaveFrom("userLeaveFrom");
      return false;
    }
    if (!applyLeaves?.LeaveTo) {
      setErrorLeaveTo("userLeaveTo");
      return false;
    }
    if (!applyLeaves?.NoOfDays) {
      setErrorNoOfDays("userNoOfdays");
      return false;
    }
    if (!applyLeaves?.LeaveType) {
      setErrorLeaveType("userLeaveType");
      return false;
    }
    if (!applyLeaves?.Reason) {
      setErrorReason("userReason");
      return false;
    }

    if (applyLeaves?.LeaveType?.Name === "Sick Leave") {
      const today = moment().startOf("day");
      const selectedFromDate = moment(applyLeaves?.LeaveFrom).startOf("day");
      const selectedToDate = moment(applyLeaves?.LeaveTo).startOf("day");

      if (!selectedFromDate.isBefore(today) || !selectedToDate.isBefore(today)) {
        toast.error("Sick Leave should not be applicable for current or future dates");
        return false;
      }
    }

    if (
      applyLeaves?.LeaveType?.Name === "Sick Leave" &&
      !medicalDocumentFile
    ) {
      setErrorMedicalDoc("userMedicalDoc");
      toast.error("Medical document is mandatory for Sick Leave");
      return false;
    }
    return true;
  };

  const [previousDate, setPreviousDate] = useState(null);

  const handleLeaveSubmit = () => {
    if (!validate()) return;

    setLoading(true);
    const formData = new FormData();

    if (leaveRequestData) {
      formData.append("Id", leaveRequestData?.Id);
    }

    formData.append("StartDate", applyLeaves.LeaveFrom);
    formData.append("EndDate", applyLeaves.LeaveTo);
    formData.append("Reason", applyLeaves.Reason);
    formData.append("NumberofDays", applyLeaves?.NoOfDays);
    formData.append("LeaveType", applyLeaves?.LeaveType?.Id);
    formData.append("LeaveFromDuration", getDurationEnumValue(leaveFromType));
    formData.append("LeaveToDuration", getDurationEnumValue(leaveToType));

    if (leaveFromSlot) {
      formData.append("LeaveFromSlot", leaveFromSlot);
    }

    if (leaveToSlot) {
      formData.append("LeaveToSlot", leaveToSlot);
    }

    // SINGLE FILE ONLY
    if (
      applyLeaves?.LeaveType?.Name === "Sick Leave" &&
      medicalDocumentFile
    ) {
      formData.append("MedicalDocuments", medicalDocumentFile);
    }

    if (applyLeaves.ApplyForUserId) {
      formData.append("ApplyForUserId", applyLeaves.ApplyForUserId);
    }

    setPreviousDate(applyLeaves.LeaveFrom || applyLeaves.LeaveTo);

    const option = {
      method: "POST",
      headers: {
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/ApplyLeave`,
      data: formData,
    };

    axios(option)
      .then((e) => {
        if (previousDate === data.StartDate && data.EndDate) {
          toast.error("0111100000 date ");
          setLoading(false);
          return false;
        } else if (e?.status === 200) {
          toast.success(e?.data?.message);
          setApplyLeaves({
            LeaveType: "",
            LeaveFrom: "",
            LeaveTo: "",
            NoOfDays: "",
            Reason: "",
            ApplyForUserId: "",
          });
          setMedicalDocumentFile(null);
          setSelectedLeaveType(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          setErrorLeaveType(false);
          setErrorLeaveFrom(false);
          setErrorLeaveTo(false);
          setErrorNoOfDays(false);
          setErrorReason(false);
          setErrorMedicalDoc(false);
          navigate("/Emp/EMPLeaves");
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        setLoading(false);

        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  const [leaveTypeData, setLeaveTypeData] = useState([]);

  const RetrieveLeaveTypes = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/GetLeaveTypes`,
    };

    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        const modifiedData = data?.map((leave) => {
          if (leave.Name === "OD") {
            return { ...leave, Name: "Outdoor Leave" };
          }
          return leave;
        });
        setLeaveTypeData(modifiedData);
        setallLeavesList(modifiedData);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    RetrieveLeaveTypes();
  }, []);

  useEffect(() => {
    let filterData = allLeavesList;

    const today = moment().startOf("day");
    const selectedDate = applyLeaves?.LeaveFrom
      ? moment(applyLeaves.LeaveFrom).startOf("day")
      : null;

    if (selectedDate) {
      if (selectedDate.isBefore(today)) {
        filterData = allLeavesList?.filter((item) => item?.Name === "Sick Leave");
      } else {
        filterData = allLeavesList?.filter((item) => item?.Name !== "Sick Leave");
      }
    }

    if (applyLeaves?.NoOfDays > 1 && applyLeaves?.NoOfDays <= 6) {
      filterData = filterData?.filter(
        (item) => item?.Name !== "Half Day" && item?.Name !== "Short Leave"
      );
    } else if (applyLeaves?.NoOfDays === 6) {
      filterData = filterData?.filter(
        (item) =>
          item?.Name === "Casual Leave" || item?.Name === "Sick Leave"
      );
    } else if (applyLeaves?.NoOfDays > 6) {
      filterData = filterData?.filter(
        (item) => item?.Name === "Casual Leave" || item?.Name === "OD"
      );
    }

    setLeaveTypeData(filterData);
  }, [applyLeaves?.LeaveFrom, applyLeaves?.NoOfDays, allLeavesList]);

  useEffect(() => {
    const today = moment().startOf("day");
    const selectedFromDate = applyLeaves?.LeaveFrom
      ? moment(applyLeaves.LeaveFrom).startOf("day")
      : null;
    const selectedToDate = applyLeaves?.LeaveTo
      ? moment(applyLeaves.LeaveTo).startOf("day")
      : null;

    if (
      applyLeaves?.LeaveType?.Name === "Sick Leave" &&
      ((selectedFromDate && !selectedFromDate.isBefore(today)) ||
        (selectedToDate && !selectedToDate.isBefore(today)))
    ) {
      setApplyLeaves((prev) => ({
        ...prev,
        LeaveType: "",
      }));
      setSelectedLeaveType(null);
      setMedicalDocumentFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      toast.error("Sick Leave should not be applicable for current or future dates");
    }
  }, [applyLeaves?.LeaveFrom, applyLeaves?.LeaveTo]);

  const handleLeaveTypeChange = (selectedOption) => {
    const today = moment().startOf("day");
    const selectedFromDate = applyLeaves?.LeaveFrom
      ? moment(applyLeaves.LeaveFrom).startOf("day")
      : null;
    const selectedToDate = applyLeaves?.LeaveTo
      ? moment(applyLeaves.LeaveTo).startOf("day")
      : null;

    if (selectedOption?.Name === "Sick Leave") {
      if (
        (selectedFromDate && !selectedFromDate.isBefore(today)) ||
        (selectedToDate && !selectedToDate.isBefore(today))
      ) {
        toast.warning("Sick Leave should not be applicable for current or future dates");
        return;
      }
    }

    if (
      applyLeaves?.NoOfDays > 2 &&
      (selectedOption?.Name === "Short Leave" ||
        selectedOption?.Name === "Half Day")
    ) {
      toast.warning(
        "Sick Leave and Half Day are not allowed for more than 2 days."
      );
      return;
    }

    if (applyLeaves?.NoOfDays > 6 && selectedOption?.Name === "Sick Leave") {
      toast.warning("Sick Leave is not allowed for more than 6 days.");
      return;
    }

    setSelectedLeaveType(selectedOption);
    setApplyLeaves({ ...applyLeaves, LeaveType: selectedOption });
    setErrorMedicalDoc(false);

    if (selectedOption?.Name !== "Sick Leave") {
      setMedicalDocumentFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }

    const todayDate = new Date();
    const fifteenDaysAgo = new Date(todayDate);
    fifteenDaysAgo.setDate(todayDate.getDate() - 30);
    const last15DaysDateString = fifteenDaysAgo.toISOString().split("T")[0];

    if (selectedOption?.Name === "Sick Leave") {
      setMinLeaveToDate(last15DaysDateString);
    } else {
      setMinLeaveToDate(null);
    }
  };

  const handleCancelFields = () => {
    setApplyLeaves({
      LeaveType: "",
      LeaveFrom: "",
      LeaveTo: "",
      NoOfDays: "",
      Reason: "",
      ApplyForUserId: "",
    });
    setMedicalDocumentFile(null);
    setSelectedLeaveType(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setErrorLeaveType(false);
    setErrorLeaveFrom(false);
    setErrorLeaveTo(false);
    setErrorNoOfDays(false);
    setErrorReason(false);
    setErrorMedicalDoc(false);
  };

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    GetProfile();
    return () => clearTimeout(timeout);
  }, []);

  const GetProfile = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/GetProfile`,
    };

    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setProfileData(data);

        if (data?.Positions?.RoleName === "HR") {
          FetchAllUsers(setAllUsers);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  const FetchAllUsers = (callback) => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Recas/GetAllUsers`,
    };

    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          const userData = JSON.parse(response?.data?.data);
          const userList = userData?.Result || [];
          callback(userList);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      setMedicalDocumentFile(null);
      return;
    }

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];
    const maxFileSize = 5 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPEG, PNG, JPG, or PDF files are allowed");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setMedicalDocumentFile(null);
      return;
    }

    if (file.size > maxFileSize) {
      toast.error("File size must not exceed 5MB");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setMedicalDocumentFile(null);
      return;
    }

    setMedicalDocumentFile(file);
    setErrorMedicalDoc(false);
    toast.success("Medical document uploaded successfully");
  };

  const handleViewMedicalFile = () => {
    if (!medicalDocumentFile) return;
    const fileURL = URL.createObjectURL(medicalDocumentFile);
    window.open(fileURL, "_blank", "noopener,noreferrer");
    setTimeout(() => {
      URL.revokeObjectURL(fileURL);
    }, 1000);
  };

  const currentDate = new Date();
  let minDate = new Date(currentDate.getTime());
  minDate.setDate(currentDate.getDate() - 30);
  minDate = minDate.toISOString().split("T")[0];

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <section
          className={
            showSidebar
              ? "EMP-addEmloyees-section"
              : "EMP-addEmloyees-section-new"
          }
        >
          <div className="EMP-addEmloyees-all-icons">
            <div>
              <p className="MAIN-HEADING">
                {leaveRequestData ? "Edit Leaves" : "Apply Leaves"}
              </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Leaves Management </p>
              <MdKeyboardArrowRight />
              <p>{leaveRequestData ? "Edit Leaves" : "Apply Leaves"}</p>
            </div>
          </div>

          <div className="EMP-Addemployee-main-container">
            <div className="EMP-Addemployee-outter-container">
              <div className="EMP-Addemployee-inner-container">
                <div className="EMP-AddEmployee-heading">
                  <p>{leaveRequestData ? "Edit Leaves" : "Apply Leaves"}</p>
                </div>

                {profileData?.Positions?.RoleName === "HR" && (
                  <div className="EMP-Addemployee-inner-box row leave-user-select-row">
                    <div
                      className="Addemployee-inputs"
                      style={{ marginBottom: "20px" }}
                    >
                      <label>Select User</label>
                      <Select
                        options={allUsers.map((user) => ({
                          value: user.Id,
                          label: `${user.UserName} (${user.Email})`,
                        }))}
                        value={selectedUser}
                        onChange={(option) => {
                          setSelectedUser(option);
                          setApplyLeaves({
                            ...applyLeaves,
                            ApplyForUserId: option?.value || "",
                          });
                        }}
                        isClearable={true}
                        placeholder="Select a user to apply leave for"
                      />
                    </div>
                  </div>
                )}

                <div className="EMP-Addemployee-inner-box row leave-form-fields-row">
                  <div className="leave-date-duration-row">
                    <div className="Addemployee-inputs leave-row-item">
                      <label>Leave From</label>
                      <input
                        value={applyLeaves.LeaveFrom}
                        type="date"
                        onChange={(e) => {
                          const selectedDate = e?.target?.value;

                          setApplyLeaves({
                            ...applyLeaves,
                            LeaveFrom: selectedDate,
                            LeaveTo: "",
                            LeaveType: "",
                            NoOfDays: "",
                          });

                          setSelectedLeaveType(null);
                          setMedicalDocumentFile(null);
                          if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                          }

                          setMinLeaveToDate(selectedDate);
                          setErrorLeaveType(false);
                        }}
                        min={minDate}
                      />
                      {errorLeaveFrom === "userLeaveFrom" &&
                      !applyLeaves?.LeaveFrom ? (
                        <span className="contact_error-dob">
                          Leave From is required.
                        </span>
                      ) : null}
                    </div>

                    {applyLeaves.LeaveFrom !== applyLeaves.LeaveTo && (
                      <>
                        <div className="Addemployee-inputs leave-row-item">
                          <label>Leave Duration</label>
                          <select
                            value={leaveFromType}
                            onChange={(e) => {
                              setLeaveFromType(e.target.value);
                              setLeaveFromSlot(null);
                            }}
                            className="leave-select-input"
                          >
                            <option
                              value="Full Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyFullDay
                              }
                            >
                              Full Day
                            </option>
                            <option
                              value="Half Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyHalfDay
                              }
                            >
                              Half Day
                            </option>
                            <option
                              value="Short Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyShortLeave
                              }
                            >
                              Short Day
                            </option>
                          </select>

                          {fromDateRestrictions?.restrictionMessage && (
                            <small className="leave-restriction-note">
                              {fromDateRestrictions.restrictionMessage}
                            </small>
                          )}
                        </div>

                        {(leaveFromType === "Half Day" ||
                          leaveFromType === "Short Day") && (
                          <div className="Addemployee-inputs leave-row-item">
                            <label>Leave Slot</label>
                            <select
                              value={leaveFromSlot || ""}
                              onChange={(e) => setLeaveFromSlot(e.target.value)}
                              className="leave-select-input"
                            >
                              <option value="">Select Slot</option>
                              {leaveFromType === "Half Day" ? (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(
                                        1
                                      )
                                    }
                                  >
                                    9:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(
                                        2
                                      )
                                    }
                                  >
                                    2:00 PM - 6:00 PM
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        1
                                      )
                                    }
                                  >
                                    9:30 AM - 11:30 AM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        2
                                      )
                                    }
                                  >
                                    11:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="3"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        3
                                      )
                                    }
                                  >
                                    2:00 PM - 4:00 PM
                                  </option>
                                  <option
                                    value="4"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        4
                                      )
                                    }
                                  >
                                    4:00 PM - 6:00 PM
                                  </option>
                                </>
                              )}
                            </select>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {applyLeaves.LeaveFrom === applyLeaves.LeaveTo &&
                    applyLeaves.LeaveFrom && (
                      <div className="leave-date-duration-row">
                        <div className="Addemployee-inputs leave-row-item">
                          <label>Leave Duration</label>
                          <select
                            value={leaveFromType}
                            onChange={(e) => {
                              setLeaveFromType(e.target.value);
                              setLeaveFromSlot(null);
                            }}
                            className="leave-select-input"
                          >
                            <option
                              value="Full Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyFullDay
                              }
                            >
                              Full Day
                            </option>
                            <option
                              value="Half Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyHalfDay
                              }
                            >
                              Half Day
                            </option>
                            <option
                              value="Short Day"
                              disabled={
                                fromDateRestrictions &&
                                !fromDateRestrictions.canApplyShortLeave
                              }
                            >
                              Short Day
                            </option>
                          </select>

                          {fromDateRestrictions?.restrictionMessage && (
                            <small className="leave-restriction-note">
                              {fromDateRestrictions.restrictionMessage}
                            </small>
                          )}
                        </div>

                        {(leaveFromType === "Half Day" ||
                          leaveFromType === "Short Day") && (
                          <div className="Addemployee-inputs leave-row-item">
                            <label>Leave Slot</label>
                            <select
                              value={leaveFromSlot || ""}
                              onChange={(e) => setLeaveFromSlot(e.target.value)}
                              className="leave-select-input"
                            >
                              <option value="">Select Slot</option>
                              {leaveFromType === "Half Day" ? (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(
                                        1
                                      )
                                    }
                                  >
                                    9:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableHalfDaySlots.includes(
                                        2
                                      )
                                    }
                                  >
                                    2:00 PM - 6:00 PM
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        1
                                      )
                                    }
                                  >
                                    9:30 AM - 11:30 AM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        2
                                      )
                                    }
                                  >
                                    11:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="3"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        3
                                      )
                                    }
                                  >
                                    2:00 PM - 4:00 PM
                                  </option>
                                  <option
                                    value="4"
                                    disabled={
                                      fromDateRestrictions &&
                                      !fromDateRestrictions.availableShortLeaveSlots.includes(
                                        4
                                      )
                                    }
                                  >
                                    4:00 PM - 6:00 PM
                                  </option>
                                </>
                              )}
                            </select>
                          </div>
                        )}
                      </div>
                    )}

                  <div className="leave-date-duration-row">
                    <div className="Addemployee-inputs leave-row-item">
                      <label>Leave To</label>
                      <input
                        type="date"
                        value={applyLeaves?.LeaveTo}
                        onChange={(e) => {
                          setApplyLeaves({
                            ...applyLeaves,
                            LeaveTo: e?.target?.value,
                            LeaveType: "",
                          });
                          setSelectedLeaveType(null);
                          setMedicalDocumentFile(null);
                          if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                          }
                          setErrorLeaveType(false);
                        }}
                        min={minLeaveToDate || minDate}
                      />
                      {errorLeaveTo === "userLeaveTo" && !applyLeaves?.LeaveTo ? (
                        <span className="contact_error-dob">
                          Leave To is required.
                        </span>
                      ) : null}
                    </div>

                    {applyLeaves.LeaveFrom !== applyLeaves.LeaveTo && (
                      <>
                        <div className="Addemployee-inputs leave-row-item">
                          <label>Leave Duration</label>
                          <select
                            value={leaveToType}
                            onChange={(e) => {
                              setLeaveToType(e.target.value);
                              setLeaveToSlot(null);
                            }}
                            className="leave-select-input"
                          >
                            <option
                              value="Full Day"
                              disabled={
                                toDateRestrictions &&
                                !toDateRestrictions.canApplyFullDay
                              }
                            >
                              Full Day
                            </option>
                            <option
                              value="Half Day"
                              disabled={
                                toDateRestrictions &&
                                !toDateRestrictions.canApplyHalfDay
                              }
                            >
                              Half Day
                            </option>
                            <option
                              value="Short Day"
                              disabled={
                                toDateRestrictions &&
                                !toDateRestrictions.canApplyShortLeave
                              }
                            >
                              Short Day
                            </option>
                          </select>

                          {toDateRestrictions?.restrictionMessage && (
                            <small className="leave-restriction-note">
                              {toDateRestrictions.restrictionMessage}
                            </small>
                          )}
                        </div>

                        {(leaveToType === "Half Day" ||
                          leaveToType === "Short Day") && (
                          <div className="Addemployee-inputs leave-row-item">
                            <label>Leave Slot</label>
                            <select
                              value={leaveToSlot || ""}
                              onChange={(e) => setLeaveToSlot(e.target.value)}
                              className="leave-select-input"
                            >
                              <option value="">Select Slot</option>
                              {leaveToType === "Half Day" ? (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableHalfDaySlots.includes(
                                        1
                                      )
                                    }
                                  >
                                    9:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableHalfDaySlots.includes(
                                        2
                                      )
                                    }
                                  >
                                    2:00 PM - 6:00 PM
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option
                                    value="1"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(
                                        1
                                      )
                                    }
                                  >
                                    9:30 AM - 11:30 AM
                                  </option>
                                  <option
                                    value="2"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(
                                        2
                                      )
                                    }
                                  >
                                    11:30 AM - 1:30 PM
                                  </option>
                                  <option
                                    value="3"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(
                                        3
                                      )
                                    }
                                  >
                                    2:00 PM - 4:00 PM
                                  </option>
                                  <option
                                    value="4"
                                    disabled={
                                      toDateRestrictions &&
                                      !toDateRestrictions.availableShortLeaveSlots.includes(
                                        4
                                      )
                                    }
                                  >
                                    4:00 PM - 6:00 PM
                                  </option>
                                </>
                              )}
                            </select>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <div className="Addemployee-inputs col-md12">
                    <label>Number of Days</label>
                    <input
                      className="no-of-days-cursor"
                      type="number"
                      value={applyLeaves?.NoOfDays}
                      onChange={(e) =>
                        setApplyLeaves({
                          ...applyLeaves,
                          NoOfDays: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorNoOfDays("userNoOfdays");
                        } else {
                          setErrorNoOfDays("false");
                        }
                      }}
                      disabled
                    />
                    {errorNoOfDays === "userNoOfdays" &&
                    !applyLeaves?.NoOfDays ? (
                      <span className="contact_error-dob">
                        Number of Days is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-inputs col-md12">
                    <div className="addemp-react-select-input">
                      <label>Leave Type</label>
                      <Select
                        classNamePrefix="EMP-leave-request-input"
                        placeholder="Select Leave Type"
                        value={applyLeaves?.LeaveType}
                        onChange={handleLeaveTypeChange}
                        options={leaveTypeData}
                        getOptionLabel={(options) => options?.Name}
                        getOptionValue={(options) => options?.Id}
                        onBlur={(e) => {
                          if (!e?.target?.value) {
                            setErrorLeaveType("userLeaveType");
                          } else {
                            setErrorLeaveType("false");
                          }
                        }}
                      />
                      {errorLeaveType === "userLeaveType" &&
                      !applyLeaves?.LeaveType ? (
                        <span className="contact_error-Addemployee">
                          Leave Type is required.
                        </span>
                      ) : null}
                    </div>

                    {applyLeaves?.LeaveType?.Name === "Sick Leave" && (
                      <div className="File-uploder medical-upload-block">
                        <label>
                          Please upload Medical Bill of the Hospital (Single File)*
                        </label>

                        <div className="medical-upload-box">
                          <input
                            type="file"
                            id="medicalDocuments"
                            onChange={handleImageChange}
                            ref={fileInputRef}
                            accept=".jpeg,.jpg,.png,.pdf"
                            className="medical-file-input"
                          />
                          <label
                            htmlFor="medicalDocuments"
                            className="medical-file-input-label"
                          >
                            Choose File
                          </label>
                          <span className="medical-file-input-text">
                            {medicalDocumentFile
                              ? medicalDocumentFile.name
                              : "No file chosen"}
                          </span>
                        </div>

                        {medicalDocumentFile && (
                          <div className="medical-file-list">
                            <div className="medical-file-item medical-file-item-single">
                              <span className="medical-file-name">
                                {medicalDocumentFile.name}
                              </span>
                              <button
                                type="button"
                                className="medical-file-view-btn"
                                onClick={handleViewMedicalFile}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        )}

                        {errorMedicalDoc === "userMedicalDoc" &&
                        !medicalDocumentFile ? (
                          <span className="contact_error-dob">
                            Medical document is required for Sick Leave
                          </span>
                        ) : null}
                      </div>
                    )}
                  </div>

                  <div className="Addemployee-inputs col-md12">
                    <label>Reason</label>
                    <textarea
                      className="reason-input"
                      cols="30"
                      rows="8"
                      value={applyLeaves?.Reason}
                      onChange={(e) =>
                        setApplyLeaves({
                          ...applyLeaves,
                          Reason: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorReason("userReason");
                        } else {
                          setErrorReason("false");
                        }
                      }}
                    />
                    {errorReason === "userReason" && !applyLeaves.Reason ? (
                      <span className="contact_error-dob">
                        Reason is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-buttons buttons-for-leave-apply">
                    <button
                      className="Addemployee-submit-button-apply-leave"
                      style={{
                        backgroundColor:
                          applyLeaves?.LeaveType &&
                          applyLeaves?.LeaveFrom &&
                          applyLeaves?.LeaveTo &&
                          applyLeaves?.NoOfDays &&
                          applyLeaves?.Reason
                            ? "#3f51b5"
                            : "rgba(0, 0, 0, .12)",
                        color:
                          applyLeaves?.LeaveType &&
                          applyLeaves?.LeaveFrom &&
                          applyLeaves?.LeaveTo &&
                          applyLeaves?.NoOfDays &&
                          applyLeaves?.Reason
                            ? "#fff"
                            : "rgba(0, 0, 0, .38)",
                      }}
                      onClick={() => handleLeaveSubmit()}
                    >
                      {leaveRequestData ? "Update" : "Submit"}
                    </button>

                    <button
                      className="Addemployee-Cancel-button-apply-leave"
                      style={{
                        backgroundColor:
                          !applyLeaves.LeaveType &&
                          !applyLeaves.LeaveFrom &&
                          !applyLeaves.LeaveTo &&
                          !applyLeaves.Reason
                            ? "rgba(0, 0, 0, 0.12)"
                            : "#F44336",
                        color:
                          !applyLeaves.LeaveType &&
                          !applyLeaves.LeaveFrom &&
                          !applyLeaves.NoOfDays &&
                          !applyLeaves.Reason
                            ? "rgba(0, 0, 0, 0.38)"
                            : "#ffffff",
                      }}
                      onClick={() => handleCancelFields()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EMPLeavesRequest;